import 'core-js/es';
import 'core-js/features/url-search-params';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Refocus from './components/Refocus/Refocus';
import App from './components/App/App';
import PreviousPathProvider from './components/Providers/PreviousPathProvider';

ReactDOM.render(
  <Router>
    <Refocus>
      <PreviousPathProvider>
        <App />
      </PreviousPathProvider>
    </Refocus>
  </Router>,
  document.getElementById('app')
);
